import React, { useState } from "react";
import { Grid } from "@mui/material";
import useOverviewApi from "src/scenes/teams/dashboard/hooks/use-overview-api";
import { useParams } from "react-router-dom";
import TeamLimitLow from "src/scenes/teams/dashboard/integrated-team-limit-low";
import IntegratedNoResponse from "src/scenes/dashboard/integrated-no-response";
import { useTeam } from "src/scenes/teams/team/team-provider";
import TeamQuestionsSection from "src/scenes/teams/dashboard/insights-components/questions-section-teams";
import teamQuestionsMockData from "src/scenes/teams/dashboard/insights-components/team-questions-mock-data";
import { useAuth } from "src/components/providers/auth-context";
import IndexesSection from "src/scenes/dashboard/overview-components/indexes-section";
import request from "src/utils/request";
import IndexesOptInPlaceholder from "src/components/indexes-opt-in-placeholder";

const TeamInsights = () => {
    const [selectedQuestion, setSelectedQuestion] = React.useState();
    const [teamIndexesOptedIn, setTeamIndexesOptedIn] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const { teamId } = useParams();
    const OverviewApi = useOverviewApi(teamId);
    const teamApi = useTeam();
    const isTeams = true;

    const { isDemo, userHasTeamsSubscription } = useAuth();

    const questions = teamQuestionsMockData;

    const getTeamIndexesSettings = React.useCallback(async () => {
        try {
            let response;
            setLoading(true);
            if (isDemo || !userHasTeamsSubscription) {
                response = (await import("src/scenes/indexes-settings/mock-data")).default;
            } else {
                response = await request(`/api/indexes/${teamId}/config`, { method: "GET" });
            }
            setTeamIndexesOptedIn(response.optedIn);
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }, [isDemo, userHasTeamsSubscription, teamId]);

    React.useEffect(() => {
        getTeamIndexesSettings();
    }, []);

    if (OverviewApi.status === "ERROR" && OverviewApi.errorCode === 418) {
        return <TeamLimitLow teamId={teamId} />;
    }

    if (OverviewApi.status === "ERROR") {
        return <IntegratedNoResponse />;
    }

    return (
        <Grid container justifyContent="space-between" spacing={4} pt={2}>
            <Grid item md={12}>
                <TeamQuestionsSection
                    isDemo={isDemo}
                    selectedQuestion={selectedQuestion}
                    setSelectedQuestion={setSelectedQuestion}
                    questions={questions}
                    teamId={teamId}
                    teamApi={teamApi}
                />
            </Grid>
            <Grid item md={12} mb={12}>
                {teamIndexesOptedIn ? (
                    <IndexesSection OverviewApi={OverviewApi} isTeams={isTeams} teamId={teamId} />
                ) : (
                    <IndexesOptInPlaceholder isTeams={isTeams} teamId={teamId} loading={loading} />
                )}
            </Grid>
        </Grid>
    );
};

export default TeamInsights;
